import React, { useReducer } from 'react';
import classNames from 'classnames';

import { retrieveVideoPlayer } from '@cbsinteractive/avia-js';

import useInterval from 'hooks/interval';

import styles from './PlayerDebugOverlay.module.scss';

interface BitrateInfo {
  bitrate: number;
  maxBitrate: number;
}

interface PlayerDebugOverlayProps {
  playerName?: string | null;
  className?: string | null;
  [key: string]: unknown;
}

const retrieveBitrateInfo = async (playerName?: string | null): Promise<BitrateInfo> => {
  try {
    const result = await retrieveVideoPlayer(playerName ?? '');
    const { bitrate, maxBitrate } = result ?? {};
    return {
      bitrate: bitrate || 0,
      maxBitrate: maxBitrate || 0,
    };
  } catch {
    return {
      bitrate: 0,
      maxBitrate: 0,
    };
  }
};

const formatBitrate = (bitrate: number): string => {
  const bitrateNum = Number(bitrate);
  if (bitrateNum > 999999) {
    return `${(bitrateNum / 1000000).toFixed(2)} Mbps`;
  }
  if (bitrateNum > 999) {
    return `${(bitrateNum / 1000).toFixed(2)} Kbps`;
  }
  return `${bitrateNum.toFixed(2)} Bps`;
};

const PlayerDebugOverlay = ({
  playerName = 'CVP',
  className = null,
  ...rest
}: PlayerDebugOverlayProps) => {
  const [{ bitrate, maxBitrate }, dispatch] = useReducer(
    (_: BitrateInfo, action: BitrateInfo) => {
      return action;
    },
    { bitrate: 0, maxBitrate: 0 },
  );
  useInterval(async () => {
    dispatch(await retrieveBitrateInfo(playerName));
  }, 5000);

  return (
    <div className={classNames(styles.overlay, className)} {...rest}>
      <span>Maximum Bitrate: {formatBitrate(maxBitrate)}</span>
      <span>Current Bitrate: {formatBitrate(bitrate)}</span>
    </div>
  );
};

export default PlayerDebugOverlay;
